import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/19/thumb-landscape.jpg"

const Post19 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">LOEWE／エレファントミニバッグ／12 x16 x9cm</span>     
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
          かわいいものを見かけるとテンションが上がるわたしたち。アニマルモチーフのバッグもその一つではないでしょうか？数多くのブランドから動物をモチーフにしたバッグが登場しています！ラクサスでもアニマルモチーフのバッグは大人気！ラクサスのバッグを使えば、個性的なバッグを選んでも飽きたらすぐに取り替えられるので、安心！コーデのワンポイントにバッグを選ぶのもいいけど、たまにはバッグをコーデの主役にするのはいかがですか？
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>LOEWE（ロエベ）/エレファント・バニー・パンダ/ミニバッグ</h2>
          <p>ロエベの人気の高いレザーアニマルシリーズは、スペイン・マドリード工房で偶然に生まれたようです。余ったレザーの切れ端に手を加えて作った、クマ形のコインパースから始まり、今もなお人気のシリーズです。シリーズの中でも、ジョナサン・アンダーソンのお気に入りは、エレファント。「コインパース」に遊び心とこれまでとは違った機能性を与えようというアイデアから、「エレファント バッグ」が誕生しました。その後もバニー・パンダと続々に可愛らしい仲間がデビューしています。丸みを帯びた耳の部分やロゴを配した底の部分は、職人によって丁寧にカラーリングされ、細部にまでこだわりぬいています。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/19/1.jpg" alt="" />
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/19/2.jpg" alt="" />
            </figure>        
        </div>
        <span className="text-center">LOEWE／エレファントミニバッグ／11 x15 x9cm</span>  
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/19/3.jpg" alt="" />
            <span className="text-center">LOEWE／バニーミニバッグ／18 x16 x13cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/19/4.jpg" alt="" />
            <span className="text-center">LOEWE／パンダミニバッグ／11 x16 x9cm</span> 
          </figure>          
        </div>
        <div className="text-max-width">
          <h2>ANTEPRIMA（アンテプリマ）のアニマーレ パンダ</h2>
          <p>垂れ目で愛らしい表情ところんとした丸みのあるフォルムが大人気！アンテプリマならではの手編みワイヤーバッグだからこそ、アクセサリー感覚で使えるアクセントに♪可愛らしい外見とは対照的に見た目以上の収納力を持っています。幅広いコーディネートに使えて、見ているだけでも癒されるバッグです。</p>
        </div>      
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/19/5.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/19/6.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">ANTEPRIMA／アニマーレ パンダ／17 x25 x6cm</span>  
        <Link to="https://laxus.co/app/pc/bags" className="view-all-button">
          ラクサスでバッグを見る
        </Link>                
        <div className="text-max-width">
          <h2>ANYA HINDMARCH（アニヤ・ハインドマーチ）のフォックス＆ハスキー</h2>
          <p>アニヤ・ハインドマーチは、アクセサリー・ブランドとして初めて、ロンドン・ファッション・ウィークでのシーズンごとのショーを実現したブランドです。つねにクリエイティビティとウィットにあふれたステージがファッション・ウィークの話題の中心です。バッグは、伝統的なレザー・クラフトを現代に置き換えた手法を追求しています。このチャーミングなクロスボディ・バッグは、アニヤが子どもの頃使っていたお財布に着想したもののようです。そんな遊び心あるデザインが大人気です！</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/19/7.jpg" alt="" />
        </figure>  
        <span className="text-center">ANYA HINDMARCH／フォックスショルダーバッグ／17 x11 x1cm</span>            
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/19/8.jpg" alt="" />
            <span className="text-center">ANYA HINDMARCH／フォックスショルダーバッグ／17 x11 x1cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/19/9.jpg" alt="" />
            <span className="text-center">ANYA HINDMARCH／ハスキーショルダーバッグ／17 x11 x1cm</span> 
          </figure>
        </div>   
        <div className="text-max-width">
          <h2>MCM（エムシーエム）のラビット ドールバッグ</h2>
          <p>韓国のアイドルや俳優にも愛用者が多く、近年若年層を中心に人気を集めていルブランド「MCM（エムシーエム）」。こちらのバッグはぬいぐるみのようなデザインがインパクト抜群な「ラビット ドールバッグ」。ラクサスならレンタルで気軽に挑戦できそう。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/19/10.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/19/11.jpg" alt="" />
          </figure>
        </div>    
        <span className="text-center">MCM／ブラックバニー／14 x35 x13cm</span>          
        <div className="text-max-width">
          <h2>GUCCI（グッチ）</h2>
          <p>グッチでは、「ビー(蜂)」や「タイガー」シリーズをはじめに、存在感のある動物モチーフが印象的です。刺繍や金具でモチーフを繊細に表現しており、絵画のように楽しめるシリーズになっています。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/19/12.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/19/13.jpg" alt="" />
          </figure>
        </div> 
        <span className="text-center">GUCCI／GGスプリーム／36 x37 x6cm</span>     
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/19/14.jpg" alt="" />
            <span className="text-center">GUCCI／ベンガル／25 x15 x1cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/19/15.jpg" alt="" />
            <span className="text-center">GUCCI／チルドレンズ／20 x19 x10cm</span> 
          </figure>
        </div>      
        <div className="text-max-width">
        <h2>Kate Spade（ケイト・スペード）</h2>
        <p>個性的で可愛く女性心をくすぐるバッグが多い、ケイト・スペード。動物たちをモチーフにしたものも人気です！一気にコーデをキュートに仕上げてくれます。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/19/16.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/19/17.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">kate spade／2WAYバッグ／19 x16 x8cm</span>     
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/19/18.jpg" alt="" />
            <span className="text-center">kate spade／ショルダーウォレット／19 x12 x3cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/19/19.jpg" alt="" />
            <span className="text-center">kate spade／ショルダーバッグ／16 x16 x10cm</span> 
          </figure>
        </div>                                      
        <Link to="https://laxus.co/app/pc/bags" className="view-all-button">
          ラクサスでバッグを見る
        </Link>                                                   
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post19

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 19}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
